import createReducer from '../helpers/CreateReducer';
import {
  ApplicationConstants,
  VoucherReorderConstants
} from '../constants/actions';

interface VoucherState {
  voucherData: {
    voucherId?: string | number;
    quantity?: number;
    [key: string]: any;
  };
  isError: boolean;
}

export const getInitialState = (): VoucherState => ({
  voucherData: {},
  isError: false
});

export default createReducer(getInitialState, {
  [`${VoucherReorderConstants.LOAD_REORDER_DATA}_SUCCESS`]: (
    state: VoucherState,
    { voucherDetails }
  ) => ({
    voucherData: voucherDetails || {},
    isError: false
  }),
  [`${VoucherReorderConstants.LOAD_REORDER_DATA}_FAILURE`]: () => ({
    isError: true
  }),
  [`${ApplicationConstants.CLEAR_FORMS}`]: getInitialState,
  [`${VoucherReorderConstants.SET_REORDER_VOUCHER_AND_AMOUNT}`]: (
    state: VoucherState,
    { quantity, voucherId }
  ) => ({
    voucherData: { ...state.voucherData, voucherId, quantity }
  })
});
